import { KText } from '@/ui-library/components/text';
import { Flex, Icon, Tooltip } from '@chakra-ui/react';
import { InfoCircle } from '@kula-ai/icons/dual-tone/InfoCircle';

export const SchLocationAvailability = ({ innerProps, data }) => {
  const {
    label,
    icon,
    showIcon = true,
    iconProps = {},
    availability,
    isDisabled,
    value,
  } = data;

  const isZoomDisabled = isDisabled && value === 'zoom';
  const isHackerRankDisabled = isDisabled && value === 'hackerrank';
  const showInfoIcon =
    isZoomDisabled || isHackerRankDisabled || availability === 0;

  let infoLabel;
  let infoLabelColor;

  if (isZoomDisabled) {
    infoLabel = 'You are not part of the connected Zoom account';
    infoLabelColor = 'pastel-1-dark';
  } else if (isHackerRankDisabled) {
    infoLabel = 'You need a HackerRank for work account to perform this action';
    infoLabelColor = 'pastel-1-dark';
  } else if (availability === 0) {
    infoLabel =
      'You have reached the limit for creating Zoom meetings today. Try again tomorrow';
    infoLabelColor = 'pastel-1-dark';
  } else {
    infoLabel = 'Not able to get Zoom availability, Please try again';
    infoLabelColor = 'pastel-1-dark';
  }

  return (
    <Flex
      {...innerProps}
      gap="5px"
      alignItems="center"
      padding="10px 10px"
      mx="6px"
      _hover={{
        bg: '#F4F4F5',
        borderRadius: '5px',
        cursor: isDisabled ? 'not-allowed' : 'pointer',
      }}
      opacity={isDisabled && '0.5'}
    >
      {showIcon && (
        <Icon as={icon} width="20px" height="20px" {...iconProps} mr="5px" />
      )}
      <Flex justifyContent="space-between" flex="1">
        <KText size="sm-regular">{label}</KText>
      </Flex>
      {showInfoIcon && (
        <Tooltip label={infoLabel}>
          <span>
            <Icon
              as={InfoCircle}
              color={infoLabelColor}
              width="20px"
              height="20px"
              {...iconProps}
              mr="5px"
            />
          </span>
        </Tooltip>
      )}
    </Flex>
  );
};
